"use client";
import React from "react";
import dynamic from "next/dynamic";
const FavoriteButton = dynamic(() => import("../controls/favorite-button"), { ssr: false });
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";

const CollectionListItemClient = ({
    productHandle,
    refresh,
    className,
    iconClassName,
}: {
    productHandle: string;
    refresh: boolean | undefined;
    className?: string;
    iconClassName?: string;
}) => {
    const { hasMouseMoved } = useMouseMovement();

    return (
        <>
            {hasMouseMoved && (
                <FavoriteButton
                    className={className ?? "w-8 h-8 md:w-10 md:h-10 absolute sm:top-4 sm:right-4 top-3 right-3 bg-white"}
                    iconClassName={iconClassName}
                    productHandle={productHandle}
                    refresh={refresh}
                />
            )}
        </>
    );
};

export default CollectionListItemClient;
